// client/src/theme/ThemeModeContext.js
import React, { createContext, useContext, useMemo, useState, useEffect } from 'react';
import { ThemeProvider, CssBaseline } from '@mui/material';
import { getAppTheme } from './theme';
import { useStore } from '../context/StoreContext';

const ThemeModeContext = createContext({ mode: 'light', toggleMode: () => {} });

export const useThemeMode = () => useContext(ThemeModeContext);

export const ThemeModeProvider = ({ children }) => {
  const { store } = useStore();
  const [mode, setMode] = useState(() => {
    const stored = localStorage.getItem('themeMode');
    if (stored === 'light' || stored === 'dark') return stored;
    return window.matchMedia?.('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
  });

  useEffect(() => {
    localStorage.setItem('themeMode', mode);
  }, [mode]);

  const toggleMode = () => setMode((prev) => (prev === 'light' ? 'dark' : 'light'));

  const theme = useMemo(
    () => getAppTheme(
      mode, store.primary_color, store.secondary_color,
      store.success_color, store.warning_color, store.error_color,
      store.background_color, store.text_color
    ),
    [
      mode, store.primary_color, store.secondary_color,
      store.success_color, store.warning_color, store.error_color,
      store.background_color, store.text_color,
    ]
  );

  return (
    <ThemeModeContext.Provider value={{ mode, toggleMode }}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        {children}
      </ThemeProvider>
    </ThemeModeContext.Provider>
  );
};
